import React, {useEffect, useState} from 'react';
import {withStyles} from "@material-ui/core";
import i18n from "../../../i18n";
import Divider from "@material-ui/core/Divider";
import FormField from "../../Form/FormField";
import Button from "@material-ui/core/Button";
import {getMutationName,getQueryName} from "../../Form/utils";
import FormAutocompleteGQL from "../../Form/FormAutocompleteGQL";
import projectQueries from "../../../queries/projectQueries";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import projectMutations from "../../../mutations/projectMutations";
import moment from "moment-business-days";
import swal from "sweetalert";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Typography from "@material-ui/core/Typography";
import PDFDocument from "../../File/PDF/PDFDocument";
import FileRenderer from "../../File/PDF/FileRenderer";
import attachmentQueries from "../../../queries/attachmentQueries";
import attachmentReferenceMutations from "../../../mutations/attachmentReferenceMutations";
import _ from "lodash";

const calculateReminder = (deadline,diff) => {
    deadline = moment(deadline);
    if(deadline.isValid()){
        deadline = deadline.businessAdd(diff)._d;
        return moment(deadline).format('YYYY-MM-DD 00:00:00');
    }
    return null;
}

const getStatusId = async (event) => {
    if(event) {
        const query = projectQueries.getProjectStatus;
        const queryName = getQueryName(query).toLowerCase();
        const {data: result} = await window.apolloClient.query({query, variables: {event: event}});

        return result[queryName] && result[queryName].id;
    }
    return event;
}

const getDateTime = (dateTime) => {
    return dateTime !== ''
        ? moment(dateTime).format('YYYY-MM-DD HH:mm:ss')
        : null;
}

const updateGracePeriods = async (data) => {

    const mutation = projectMutations.updateProject ;
    const mutationName = getMutationName(mutation);

    let statusId = null;

    if(data.second_grace_period) {
        statusId = await getStatusId('first_grace_period');
        data.reminder = calculateReminder(data.second_grace_period,1);
    } else if(data.first_grace_period) {
        statusId = await getStatusId('deadline');
        data.reminder = calculateReminder(data.first_grace_period,1);
    } else {
        statusId = await getStatusId('deficiency_notified');
        data.reminder = null;
    }

    if(statusId) {
        data.status_id = statusId;
    }

    const {data: result} = await window.apolloClient.mutate({mutation, variables: {...data}});
    return result[mutationName];
};

const saveAttachment = async (fileData, projectId) => {

    const query = attachmentQueries.findAttachmentReference;
    const queryName = getMutationName(query);
    const variables = {id:fileData.id}

    const{data:reference} = await window.apolloClient.query({ query, variables, errorPolicy: "all"});
    const data = reference[queryName] || null;
    const attachmentReferences = data['attachmentReferences'] || null;
    const referenceExists = attachmentReferences && attachmentReferences.length && attachmentReferences.find(ref => ref.project_id !== null );

    if(!referenceExists) {

        const mutation = attachmentReferenceMutations.createAttachmentReference;
        const {data: result} = await window.apolloClient.mutate({mutation, variables: { project_id: parseInt( projectId ) , attachment_id: fileData.id}, errorPolicy: "all"});

        return result['createAttachmentReference'];
    }
};

const saveProjectData = async (values) => {

    const projectId = values.id || null;
    const data = projectId && await updateGracePeriods({
        id: projectId,
        first_grace_period: getDateTime(values.first_grace_period),
        second_grace_period: getDateTime(values.second_grace_period),
    })

    if (values.files && values.files.length > 0) {
        for (const file of values.files) {
            await saveAttachment(file, projectId)
        }
    }
    return data;
}

const updateProject = (values,saveOnly) => {
    //@todo show info about rendered pdf like in form
    return swal({
        text:'Nachfrist wird ' + (saveOnly ? 'angelegt!' : 'angelegt und versendet!'),
        button: {
            text: "ok",
            closeModal: false,
        },
        closeOnClickOutside: saveOnly,
        closeOnEsc: saveOnly,
    }).then(async res => {
        if (res) {
           const data = await saveProjectData(values);
            if (data) {
                return swal({
                   text: i18n.get('deficiency.grace_period.saved'),
                   icon: 'success',
                   timer: 4000,
                }).then(() => {
                    if(data.id > 0) {
                        window.location.href = `/project`;
                    }
                });
            } else {
                return swal("Ooops!", "Da ist etwas schief gegangen!", "error");
            }
        }
    });
}

const openCompletionDialog = (type) => {
    type = i18n.get('deficiency.pdf.' + type);
    return swal({
        title: i18n.get('deficiency.pdf.completion_dialog_title',{type: type || ''}),
        text: i18n.get('deficiency.pdf.complete_history_request'),
        buttons: {
            cancel: i18n.get('default.cancel'),
            deny: i18n.get('default.no'),
            confirm: {
                text: i18n.get('default.yes'),
                value: 'confirm'
            },
        }
    });
}

const openRenderDialog = (type) => {
    type = i18n.get('deficiency.pdf.' + type);
    return swal({
        text: i18n.get('deficiency.pdf.render_dialog_title',{type: type || ''}),
        button: {
            text: "ok",
            closeModal: false,
        },
        closeOnClickOutside: false,
        closeOnEsc: false,
        allowOutsideClick: false,
    });
}

const GracePeriodDialog = (props) => {

    const {
        classes,
        open,
        handleClose,
        closedStatusIds,
    } = props;

    const [values,setValues] = useState(null);
    const [isExpired,setIsExpired] = useState(false);
    const [projectId,setProjectId] = useState('');
    const [firstGracePeriod,setFirstGracePeriod] = useState('');
    const [secondGracePeriod,setSecondGracePeriod] = useState('');

    const changeIsExpired = e => setIsExpired(e);
    const changeProjectId = e => setProjectId(e);
    const changeFirstGracePeriod = e => setFirstGracePeriod(e);
    const changeSecondGracePeriod = e => setSecondGracePeriod(e);

    const changeValues = data => {

        if(data.buildings && data.buildings.length && data.buildings[0].apartment) {
            const apartment = data.buildings[0].apartment;
            const {number:apartment_number, ...rest} = apartment;
            data = {...{apartment_number,...rest},...data};
        }

        setValues({
            building_parent: data.buildings[0].building.parent || null,
            contact: data.contacts[0].contact || null,
            files: data.files || [],
            ...data,
        });
    }

    const closeDialog = () => {
        changeIsExpired(false);
        changeProjectId('');
        changeFirstGracePeriod('');
        changeSecondGracePeriod('');
        handleClose();
    }

    // requesting procedure ...
    const [requesting,setRequesting] = useState(false);
    const [rendered,setRendered] = useState(false);
    const [isComplete,setIsComplete] = useState(false);

    const requestState = e => setRequesting(e);
    const renderState = e => setRendered(e);

    useEffect(() => {
        if(!requesting) {
            renderState(false);
        }
    },[requesting]);

    const handleSubmit = (saveOnly) => {
        closeDialog();
        if(saveOnly) {
            updateProject(values,saveOnly).then();
        } else {
            const type = secondGracePeriod ? 'second_grace_period' : 'first_grace_period';
            openRenderDialog(type)
                .then(res => (res && requestState(true)))
        }
    }

    useEffect(() => {
        if(values && values.rendered && !requesting && !rendered) {
            updateProject(values).then();
        }
    },[values,requesting,rendered])

    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={closeDialog}
                disableBackdropClick={true}
                className={classes.dialog}
                fullWidth={true}
                maxWidth={'sm'}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title" className={classes.dialogTitle}  disableTypography>
                    <Typography variant="h6" color={"primary"}>
                        {i18n.get('deficiency.add_grace_period')}
                    </Typography>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={closeDialog}>
                        <Icon>close</Icon>
                    </IconButton>
                    <div style={{fontSize:11,color:'#999999'}}>
                        Hinweise:
                        <div>{i18n.get('deficiency.dialog.hints.grace_period.selection')}</div>
                        <div>{i18n.get('deficiency.dialog.hints.grace_period.current_date')}</div>
                        <div>{i18n.get('deficiency.dialog.hints.grace_period.date_comparison')}</div>
                        <div>{i18n.get('deficiency.dialog.hints.grace_period.notification')}</div>
                    </div>

                </DialogTitle>
                <Divider/>
                <DialogContent className={classes.dialogContent}>
                    <FormAutocompleteGQL
                        query={projectQueries.getOpenProjectsByNumber}
                        labelName={'name'}
                        valueName={'id'}
                        withoutValue={{status_id: closedStatusIds }} // without closed projects
                        name="project_id"
                        label={i18n.get('project.deficiency.select')}
                        isClearable={true}
                        defaultOptions
                        mutateData={ data => data.number_internal + ' - ' + data.name }
                        onChange={selectedOption => {
                            if(selectedOption && selectedOption.entity) {
                                changeValues(selectedOption.entity)
                                changeProjectId(selectedOption.entity.id || '');
                                changeFirstGracePeriod(selectedOption.entity.first_grace_period || '');
                                changeSecondGracePeriod(selectedOption.entity.second_grace_period || '');
                                changeIsExpired(false);
                                if( selectedOption.entity.first_grace_period &&
                                    moment().isAfter( selectedOption.entity.first_grace_period )
                                ) {
                                    changeIsExpired(true);
                                }
                            } else {
                                changeProjectId('');
                                changeFirstGracePeriod('');
                                changeSecondGracePeriod('');
                            }
                        }}
                    />
                    {projectId && (
                        <React.Fragment>
                            <FormField
                                type="date"
                                name="first_grace_period"
                                label={i18n.get('project.deficiency.date.first_grace_period')}
                                value={firstGracePeriod.substring(0, 10)}
                                InputLabelProps={{shrink: true}}
                                onChange={entity => {
                                    changeIsExpired(false);
                                    changeFirstGracePeriod(entity.target.value);
                                    values.first_grace_period = getDateTime(entity.target.value);
                                    values.second_grace_period = '';
                                    changeValues(values);
                                }}
                                disabled={isExpired}
                            />
                            {firstGracePeriod && (
                                <FormField
                                    type="date"
                                    name="second_grace_period"
                                    label={i18n.get('project.deficiency.date.second_grace_period')}
                                    error={'test'}
                                    value={ secondGracePeriod ? secondGracePeriod.substring(0, 10) : ''}
                                    InputLabelProps={{shrink: true}}
                                    onChange={entity => {
                                        if(moment(entity.target.value).isAfter(firstGracePeriod)
                                            && moment().isBefore( entity.target.value ) ) {
                                            changeSecondGracePeriod(entity.target.value)
                                            values.second_grace_period = getDateTime(entity.target.value);
                                            changeValues(values);
                                        } else {
                                            changeSecondGracePeriod('');
                                        }
                                    }}
                                    disabled={moment().isAfter( secondGracePeriod )}
                                />
                            )}
                        </React.Fragment>
                    )}
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    {projectId && moment().isAfter( secondGracePeriod )
                        ? (
                            <Button
                                component={'a'}
                                variant={'contained'}
                                color={'primary'}
                                size={'small'}
                                onClick={() => window.location.href = `/project/${projectId}/edit` }
                            >
                                {i18n.get('deficiency.edit')}
                            </Button>
                        )
                        : (
                            projectId && (moment().isBefore( firstGracePeriod ) || moment().isBefore( secondGracePeriod )) && (
                                <React.Fragment>
                                    {/*!isExpired && (*/
                                        <Button
                                            component={'a'}
                                            variant={'contained'}
                                            color={'primary'}
                                            size={'small'}
                                            onClick={() => handleSubmit(false)}
                                        >
                                            {i18n.get('deficiency.save_and_send')}
                                        </Button>
                                    /*)*/}
                                    <Button
                                        component={'a'}
                                        variant={'contained'}
                                        color={'primary'}
                                        size={'small'}
                                        style={{marginLeft:10}}
                                        onClick={() => handleSubmit(true)}
                                    >
                                        {i18n.get('default.save')}
                                    </Button>
                                </React.Fragment>
                            )
                        )}
                </DialogActions>
            </Dialog>

            {requesting && !rendered && !isComplete && (
                <FileRenderer
                    requesting={requesting}
                    renderState={renderState}
                    document={<PDFDocument values={values} />}
                    values={values}
                    onRendered={(file)=>{
                        setIsComplete(true);
                        values.files.push(file);
                        values.rendered = { id:file.id, name:file.name };
                        changeValues(values);
                        requestState(false);
                    }}
                    {...props}
                />
            )}
        </React.Fragment>
    );
};

const styles = theme => ({
    dialog: {
        minHeight:700,
    },
    dialogTitle: {
        color: theme.colors.primary,
    },
    dialogContent: {
        overflow:'visible',
    },
    dialogActions: {
        paddingRight: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing.unit * 1.2,
        top: theme.spacing.unit * 2,
    },
});

export default withStyles(styles)(GracePeriodDialog);
